import { BASE_FONT_SIZE } from '../constants/enum';
/**
 * Converts a pixel value to a rem value based on a base font size.
 */
export const pxToRem = (px) => {
    const number = parseInt(String(px), 10);
    return `${number / BASE_FONT_SIZE}rem`;
};
//# sourceMappingURL=px-to-rem.js.map